import React from 'react';
import { Link, useParams } from 'react-router-dom';

const TITLES = {
  'terms-of-service': 'Terms of Service',
  'privacy-policy': 'Privacy Policy',
  'refund-policy': 'Refund Policy',
  'confidentiality-agreement': 'Confidentiality Agreement',
  'code-of-conduct-satisfinders': 'Code of Conduct for satisFINDERS®',
};

export default function SatisfinderLegalPage() {
  const { slug } = useParams();
  const title = TITLES[slug] || 'Legal document';
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[#E2E8F0]">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/satisfinder" className="flex items-center gap-2">
            <img src="/satisfind-logo.png" alt="satisFIND" style={{ height: 36, width: 'auto' }} />
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#1A3E6F]">Legal</p>
        <h1 className="font-['Montserrat'] text-3xl lg:text-4xl font-bold mt-2">{title}</h1>
        <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl p-6 mt-8 text-sm text-[#475569] leading-relaxed">
          <p><strong>Placeholder — full copy pending publication.</strong></p>
          <p className="mt-3">
            The final {title} will be published from Admin &gt; Content Pages. This page will render the
            latest published version when available.
          </p>
        </div>
        <p className="text-xs text-[#64748B] mt-8">
          <Link to="/satisfinder" className="text-[#1A3E6F] hover:underline">← Back to satisFINDER®</Link>
        </p>
      </main>
    </div>
  );
}
